import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Select } from "antd";
function AreaMultiSelect({
  value,
  onChange,
  placeholder = "Select areas",
  areas = [],
}) {
  const options = useMemo(
    () => areas.map((area) => ({ label: area, value: area })),
    [areas],
  );

  return (
    <Select
      mode="multiple"
      showSearch
      allowClear
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      options={options}
      filterOption={(input, option) =>
        (option?.label ?? "")
          .toString()
          .toLowerCase()
          .includes(input.toLowerCase())
      }
      maxTagCount={3}
      className="form-control store_input_field"
      style={{ width: "100%" }}
      dropdownStyle={{ zIndex: 9999999 }}
    />
  );
}

AreaMultiSelect.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  areas: PropTypes.arrayOf(PropTypes.string),
};

export default AreaMultiSelect;
